import React from 'react';
import GatsbyLink from './GatsbyLink';
// import NextLink from "./NextLink";

// const StandardLink = props => {
//   const { url, children } = props;
//   const data = { ...props };
//   delete data.url;
//   delete data.children;

//   return (
//     <a href={url} {...data} data-default-link="true">
//       {children}
//     </a>
//   );
// };

const Link = props => {
  return (
    <>
      {/**
       * GATSBY Rendering
       */}
      {/* {(process.env.GATSBY_ENABLED) ? (
             
            ) : (
                <StandardLink {...props} />
            )} */}

      {/**
       * NEXTJS Rendering
       */}
      {/* {(process.env.NEXT_PUBLIC_ENABLED) ? (
                <NextLink {...props} />
            ) : (
                <StandardLink {...props} />
            )} */}
      <GatsbyLink {...props} />
      {/* <StandardLink {...props} /> */}
    </>
  );
};

export default Link;
